import MainRouter from "src/Navigation/MainRouter";
import Block from "./UIKit/Components/Block";
import Navbar from "./Components/Navbar/Navbar";

function App() {
  return (
    <Block className="min-h-screen flex bg-background">
      <Navbar />
      <Block className={`flex-1 lg:pl-64`}>
        <Block className={`max-w-7xl mx-auto  px-4 sm:px-6 lg:px-0  py-8`}>
          <MainRouter />
        </Block>
      </Block>
    </Block>
  );
}

export default App;
